<template>
  <div id="absent">
    <van-divider>缺考信息</van-divider>
    <div>
      <el-form label-position="left" class="m-4 text-left">
        <el-form-item label-width="25%" size="mini">
          <template slot="label">
            <i class="fa fa-fw fa-map-marker"></i>
            考点
          </template>
          <template>{{AbsentParams.AddrName}}</template>
        </el-form-item>
        <el-form-item label-width="25%" size="mini">
          <template slot="label">
            <i class="fa fa-fw fa-bars"></i>
            场次
          </template>
          <template>{{AbsentParams.BeginTime}}</template>
        </el-form-item>
        <el-form-item label-width="25%" size="mini">
          <template slot="label">
            <i class="fa fa-fw fa-user"></i>
            考生
          </template>
          <template>{{AbsentParams.StudentNum}}</template>
        </el-form-item>
        <el-form-item label-width="25%">
          <template slot="label">
            <i class="fa fa-fw fa-vcard-o"></i>
            参考值
          </template>
          <template
            type="info"
            size="small"
            plain
          >
            已签到考生<span style="font-weight: bold;"> {{AbsentParams.AttendNum}} </span>人 <br/> 
            未签到考生<span style="font-weight: bold;"> {{AbsentParams.StudentNum-AbsentParams.AttendNum}} </span>人
          </template>
        </el-form-item>
        <el-form-item label-width="25%">
          <template slot="label">
            <i class="fa fa-fw fa-male"></i>
            缺考
          </template>
          <el-input type="number" v-model="AbsentParams.AbsentNum" style="width:50%" size="mini"></el-input>
          <van-button
            icon="edit"
            hairline
            class="float-right w-50"
            style="margin:7px auto;height:28px;border-radius:5px;"
            size="small"
            type="info"
            @click="upAbsentBtn"
          >{{absentAttribute.text}}</van-button>
        </el-form-item>
        <el-form-item label-width="25%" size="mini">
          <template slot="label">
            <i class="fa fa-fw fa-pie-chart"></i>
            缺考率
          </template>
          <template>
            {{AbsentRatio}}
            <small>%</small>
          </template>
        </el-form-item>
      </el-form>
      <div class="m-4 pb-4"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "absent",
  data() {
    return {
      AbsentParams: {
        AddrID: 0,
        BeginTime: "",
        AbsentNum: 0,
        TotalStuNum: 0,
        StudentNum: 0,
        AddrName: "",
        OrganID: "",
        WorkID: "",
        AttendNum: 0,
        SplitProcessID: ""
      },
      AbsentRatio: 0,
      absentAttribute: {
        text: "上报缺考人数"
      }
    };
  },
  watch: {
    "AbsentParams.AbsentNum"() {
      this.computeAbsentRatio();
    }
  },
  props: {
    SplitProcessID: String, //分解环节ID
    ProcessData: Object, //工作环节数据
    ProcessRefresh: Function, //工作环节刷新事件
    completeBtnAttribute: Object //工作环节上报完成按钮
  },
  components: {},
  methods: {
    upAbsentBtn() {
      //判断缺考数量是否大于考生数
      if (this.AbsentParams.AbsentNum > this.AbsentParams.StudentNum) {
        this.$toast("缺考人数不能大于考生数;");
        return;
      }
      //提交考生缺考人数
      this.apiAbsentReportPut(
        {
          WorkID: this.AbsentParams.WorkID,
          SplitProcessID: this.SplitProcessID,
          AbsentNum: this.AbsentParams.AbsentNum
        },
        this,
        res => {
          this.$toast(res.message);
          if (res.code == 20000) {
            this.drawData();
          }
        }
      );
    },
    attendBtn() {
      this.AbsentParams.AbsentNum =
        this.AbsentParams.StudentNum - this.AbsentParams.AttendNum;
      this.upAbsentBtn();
    },
    drawData() {
      //获取缺考上报状态
      this.apiAbsentReportGet(
        {
          WorkID: this.getWork().WorkID,
          SplitProcessID: this.SplitProcessID
        },
        this,
        res => {
          if (res.code == 20000) {
            if (res.data.AbsentNum > 0) {
              this.absentAttribute.text = "更新缺考人数";
            }
            this.AbsentParams = res.data;
            this.computeAbsentRatio();
            if (this.AbsentParams.AbsentNum == null) {
              this.completeBtnAttribute.disabled = true;
            } else {
              this.completeBtnAttribute.disabled = false;
            }
          }
        }
      );
    },
    computeAbsentRatio() {
      this.AbsentRatio = parseFloat(
        (this.AbsentParams.AbsentNum / this.AbsentParams.StudentNum) * 100
      ).toFixed(2);
    }
  },
  created() {
    this.drawData();
    this.completeBtnAttribute.tips="需要先上报缺考人数后上报状态";
  },
  mounted() {}
};
</script>

<style scoped>
</style>